import { useState, useEffect } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap-icons/font/bootstrap-icons.css'; 

const ManageProfile = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    password: "",
    aadhaar: "",
    pan: "",
    user_id: "",
    bank_name: "",
    account_holder_name: "",
    account_no: "",
    ifsc: "",
    front: "",
    back: "",
    pan_img: "",
  });

  const [existingFiles, setExistingFiles] = useState({
  pan: null,
  aadhaarFront: null,
  aadhaarBack: null,
});

   const [showPassword, setShowPassword] = useState(false);
  const [frontFile, setFrontFile] = useState(null);
  const [backFile, setBackFile] = useState(null);
  const [panFile, setPanFile] = useState(null);
  const [popup, setPopup] = useState({ message: "", type: "" });
  const [activeTab, setActiveTab] = useState("general");

  const [showPanPreview, setShowPanPreview] = useState(false);
  const [aadhaarFront, setAadhaarFront] = useState(null);
  const [aadhaarBack, setAadhaarBack] = useState(null);
  const [showAadhaarFrontPreview, setShowAadhaarFrontPreview] = useState(false);
  const [showAadhaarBackPreview, setShowAadhaarBackPreview] = useState(false);

  const [userData, setUserData] = useState({});
  const [userId, setUserId] = useState(null);


  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("userData")) || {};
    setUserData(storedUser);
    setUserId( storedUser.user_id || null);

    if (storedUser) {
      setFormData({
        id:storedUser.id ,
        name: storedUser.name || "",
        phone: storedUser.phone || "",
        email: storedUser.email || "",
        password: storedUser.password || "",
        aadhaar: storedUser.aadhaar || "",
        pan: storedUser.pan || "",
        user_id: storedUser.user_id || "",
        bank_name: storedUser.bank_name || "",
        account_holder_name: storedUser.account_holder_name || "",
        account_no: storedUser.account_no || "",
        ifsc: storedUser.ifsc || "",
        front: "",
        back: "",
        pan_img: "",
      });
    }
  }, []);

  useEffect(() => {
  if (userData) {
    setExistingFiles({
      pan: userData.pan_img || null,
      aadhaarFront: userData.front || null,
      aadhaarBack: userData.back || null,
    });
  }
}, [userData]);

  if (!userId) return <p className="text-center mt-5">Loading profile...</p>;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e, setFile) => {
    const file = e.target.files[0];
    if (!file) return;

    const validTypes = ["image/jpeg", "image/png", "application/pdf"];
    if (!validTypes.includes(file.type)) {
      setPopup({ message: "Only JPG, PNG, or PDF files are allowed", type: "error" });
      setFile(null);
      e.target.value = "";
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      setPopup({ message: "File size must be less than 5MB", type: "error" });
      setFile(null);
      e.target.value = "";
      return;
    }

    setPopup({ message: "", type: "" });
    setFile(file);
  };

  const handleSaveChange = async (e) => {
  e.preventDefault();

  const dataToSend = new FormData();

  Object.entries(formData).forEach(([key, value]) => {
    if (value !== "" && value !== null) dataToSend.append(key, value);
  });
  if (frontFile || aadhaarFront) dataToSend.append("front", aadhaarFront || frontFile);
  if (backFile || aadhaarBack) dataToSend.append("back", aadhaarBack || backFile);
  if (panFile) dataToSend.append("pan_img", panFile);

  try {
    const res = await axios.put(
      `https://api.bigfresh.in/update-user/${userId}`,
      dataToSend,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

   
    localStorage.setItem("userData", JSON.stringify(res.data.user));
    setUserData(res.data.user);

    toast.success("Profile updated successfully!", { position: "top-center" });

  } catch (err) {
    console.error(err);
    setPopup({ message: "Update failed", type: "error" });
    toast.error("Failed to update the profile", { position: "top-center" });
  }
};



  return (
    <div className="container my-4">
      <div className="d-flex align-items-center mb-3">
   
        <h3 className="fw-bold text-success text-center">Manage Profile</h3>
      </div>

      

      {/* Tabs */}
      <ul className="nav nav-tabs mb-3">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "general" ? "active" : ""}`}
            onClick={() => setActiveTab("general")}
          >
            General
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "credential" ? "active" : ""}`}
            onClick={() => setActiveTab("credential")}
          >
            Credential
          </button>
        </li>
        {/* <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "document" ? "active" : ""}`}
            onClick={() => setActiveTab("document")}
          >
            Document
          </button>
        </li> */}
      </ul>

      {/* Tab Contents */}
      {activeTab === "general" && (
        <form className="row g-3" onSubmit={handleSaveChange}>
          <div className="col-md-4">
            <label className="form-label">Name</label>
            <input className="form-control" name="name" value={formData.name} onChange={handleChange} />
          </div>
          <div className="col-md-4">
            <label className="form-label">Email</label>
            <input className="form-control" name="email" value={formData.email} onChange={handleChange} />
          </div>
          <div className="col-md-4">
            <label className="form-label">Phone</label>
            <input className="form-control" name="phone" value={formData.phone} onChange={handleChange} />
          </div>
          <div className="col-12">
            <button className="btn btn-success" type="submit">Save Changes</button>
          </div>
        </form>
      )}

      {activeTab === "credential" && (
        <form className="row g-3" onSubmit={handleSaveChange}>
          <div className="col-md-6">
            <label className="form-label">User ID</label>
            <input className="form-control" value={formData.user_id} disabled />
          </div>
         <div className="col-md-6">
  <label className="form-label">Password</label>
  <div className="input-group">
    <input
      type={showPassword ? "text" : "password"}
      className="form-control"
      name="password"
      value={formData.password}
      onChange={handleChange}
    />
     <span
      className="input-group-text bg-white border-start-0"
      style={{ cursor: "pointer", padding: "0 0.5rem", height: "45px" }}
      onClick={() => setShowPassword(!showPassword)}
    >
      <i
        className={showPassword ? "bi bi-eye-slash" : "bi bi-eye"}
        style={{ fontSize: "1.1rem" }}
      ></i>
    </span>
  </div>
</div>

          <div className="col-12">
            <button className="btn btn-success" type="submit">Save Changes</button>
          </div>
        </form>
      )}

      {/* {activeTab === "document" && (
        <form className="row g-3" onSubmit={handleSaveChange}>
          <div className="col-md-4">
            <label className="form-label">PAN</label>
            <input className="form-control mb-1" name="pan" value={formData.pan} onChange={handleChange} />
            <input className="form-control mb-1" type="file" onChange={(e) => handleFileChange(e, setPanFile)} />
         
  {panFile ? (
    <button
      className="btn btn-secondary btn-sm mb-2"
      type="button"
      onClick={() => setShowPanPreview(true)}
    >
      Preview New File
    </button>
  ) : existingFiles.pan ? (
    <button
      className="btn btn-secondary btn-sm mb-2"
      type="button"
      onClick={() => setShowPanPreview(true)}
    >
      Preview Existing File
    </button>
  ) : null}
          </div>

          <div className="col-md-4">
            <label className="form-label">Aadhaar Front</label>
            <input className="form-control mb-1" type="file" onChange={(e) => handleFileChange(e, setAadhaarFront)} />
             {aadhaarFront || existingFiles.aadhaarFront ? (
        <button
          className="btn btn-secondary btn-sm mb-2"
          type="button"
          onClick={() => setShowAadhaarFrontPreview(true)}
        >
          Preview Existing File
        </button>
      ) : null}
          </div>

          <div className="col-md-4">
            <label className="form-label">Aadhaar Back</label>
            <input className="form-control mb-1" type="file" onChange={(e) => handleFileChange(e, setAadhaarBack)} />
             {aadhaarBack || existingFiles.aadhaarBack ? (
        <button
          className="btn btn-secondary btn-sm mb-2"
          type="button"
          onClick={() => setShowAadhaarBackPreview(true)}
        >
          Preview ExistingFile
        </button>
      ) : null}
          </div>

          <div className="col-12">
            <button className="btn btn-success" type="submit">Save Changes</button>
          </div>


        {showPanPreview && (panFile || existingFiles.pan) && (
  <PreviewModal file={panFile || existingFiles.pan} onClose={() => setShowPanPreview(false)} />
)}

          {showAadhaarFrontPreview && (aadhaarFront || existingFiles.aadhaarFront) && (
      <PreviewModal
        file={aadhaarFront || existingFiles.aadhaarFront}
        onClose={() => setShowAadhaarFrontPreview(false)}
      />
    )}

    {showAadhaarBackPreview && (aadhaarBack || existingFiles.aadhaarBack) && (
      <PreviewModal
        file={aadhaarBack || existingFiles.aadhaarBack}
        onClose={() => setShowAadhaarBackPreview(false)}
      />
    )}
        </form>
      )} */}

          <ToastContainer />
    </div>
  );
};





export default ManageProfile;


function PreviewModal({ file, onClose }) {
  const fileUrl =
    typeof file === "string"
      ? `https://api.bigfresh.in/uploads/${file}` 
      : URL.createObjectURL(file);          

  return (
    <div className="modal show d-block" tabIndex="-1" role="dialog">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Preview</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body text-center">
            <img src={fileUrl} alt="Preview" className="img-fluid" />
          </div>
        </div>
      </div>
    </div>
  );
}


